"use client";

import Carousel from "./common/Carousel";
import FadeDiv from "./common/FadeDiv";
import HappyCustomersCard from "./HappyCustomersCard";
import React from "react";
import SectionTitle from "./common/SectionTitle";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

const HappyCustomers: React.FC = () => {
  const { t } = useTranslation();

  const testimonials = Array.from({ length: 4 }, (_, i) => ({
    quote: t(`happyCustomers.testimonials.${i}.quote`),
    name: t(`happyCustomers.testimonials.${i}.name`),
    organization: t(`happyCustomers.testimonials.${i}.organization`),
  }));

  return (
    <div className={clsx("max-w-8xl", "mx-auto")}>
      <FadeDiv className={clsx("border-l", "border-r", "border-gray-200")}>
        <hr
          className={clsx("absolute", "w-screen", "left-0", "border-gray-200")}
        />
        <SectionTitle
          title={t("happyCustomers.title")}
          className="!p-0 !pt-16 !pb-6 text-[40px] md:text-left md:max-w-8xl ml-6"
        />
        <Carousel
          itemWidth={{ default: "100%", md: "50%" }}
          showPageIndicator={false}
          itemClassName="!p-0 border-none"
          items={testimonials.map((feature, index) => (
            <HappyCustomersCard
              key={index}
              quote={feature.quote}
              name={feature.name}
              organization={feature.organization}
            />
          ))}
        />
        <div className={clsx("h-12", "w-full", "relative")}>
          <div
            className={clsx(
              "absolute",
              "h-16",
              "w-full",
              "bg-white",
              "mt-[-1rem]"
            )}
          ></div>
        </div>
      </FadeDiv>
    </div>
  );
};

export default HappyCustomers;
